module.exports = __webpack_public_path__ + "static/media/9.21076af5.jpg";